import React from 'react';

// Renders streaming AI text with a blinking cursor while in progress
export default function StreamingText({ text, loading, style }) {
  if (!text && !loading) return null;
  return (
    <span style={style}>
      {text}
      {loading && (
        <span style={{
          display: 'inline-block',
          width: '2px',
          height: '1.1em',
          background: '#38bdf8',
          marginLeft: '2px',
          verticalAlign: 'text-bottom',
          borderRadius: '1px',
          animation: 'blink 0.9s step-end infinite',
        }} />
      )}
    </span>
  );
}
